module.exports = __webpack_public_path__ + "static/media/water-supply-1-bg.c4bd1add.jpg";